module.exports = __webpack_public_path__ + "media/images/new-ui-images/calendar-icon-eb094ec3d7a34cba3576749a4cf83402.svg";